import $ from "jquery";

$(function() {
    const $bottomnavbar = $("#bottomnavbar");
    $bottomnavbar.find(".backbutton").on("click", function() {
        history.back();
    });
    $bottomnavbar.find(".notfall").on("click", function() {
        if(window.location.hash == "#3_1") {
            window.location.href = "/notfall";
        }
    });
});
